import React from 'react'
import smartDate from '@qrohlf/smart-date'
import * as urlHelpers from 'lib/urlHelpers'
import styles from './Comment.scss'

export class Comment extends React.PureComponent {
  confirmAndDelete = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (window.confirm('Are you sure you want to delete this comment?')) {
      this.props.onDelete()
    }
  }

  render () {
    const {comment, canDelete, showTime} = this.props

    return (
      <div className={styles.Comment}>
        <img className={styles.userIcon}
          title={comment.user.name}
          alt={comment.user.name}
          src={urlHelpers.photoMilli(comment.user.highlighted_photo_id)} />
        <div className={styles.content}>
          <div className={styles.header}>
            <a href={`/users/${comment.user.id}`}>{comment.user.name}</a>
            <span className={styles.dot}>∙</span>
            <span className={styles.date} title={showTime && smartDate(comment.created_at, {includeTime: true, includeYear: true})}>
              {smartDate(comment.created_at, {includeTime: !!showTime, includeYear: !showTime})}</span>
            {canDelete &&
              <span>
                <span className={styles.dot}>∙</span>
                <a href='#' className={styles.delete} onClick={this.confirmAndDelete}>delete</a>
              </span>}
          </div>
          <div className={styles.body}>
            {comment.comment}
          </div>
        </div>
      </div>
    )
  }
}
